var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{ 'badge-gray': !_vm.unlocked },attrs:{"src":require('@/assets/badges/' + _vm.imageUrl),"alt":("Insignia '" + _vm.title + "'"),"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }